var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkLimiterEnabledMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 61,
    viewBox: "0 0 77 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6971 56.0174C41.4072 56.0174 43.6042 53.8204 43.6042 51.1103C43.6042 48.4002 41.4072 46.2032 38.6971 46.2032C35.987 46.2032 33.79 48.4002 33.79 51.1103C33.79 53.8204 35.987 56.0174 38.6971 56.0174ZM38.6971 60.9244C44.1173 60.9244 48.5112 56.5305 48.5112 51.1103C48.5112 45.6901 44.1173 41.2962 38.6971 41.2962C33.2769 41.2962 28.883 45.6901 28.883 51.1103C28.883 56.5305 33.2769 60.9244 38.6971 60.9244Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6153 17.0062C67.1397 7.09657 53.7879 0.924423 38.9945 0.924423C23.5892 0.924423 9.74724 7.61772 0.218018 18.2548L4.0956 21.7262C12.6719 12.1529 25.1296 6.12899 38.9943 6.12899C52.3084 6.12899 64.325 11.6839 72.853 20.6026L76.6153 17.0062Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.091 24.1989C61.5105 16.2712 50.829 11.3334 38.9943 11.3334C26.6701 11.3334 15.5966 16.688 7.97325 25.1976L11.8508 28.669C18.5213 21.2232 28.2105 16.538 38.9941 16.538C49.3495 16.538 58.6958 20.8586 65.3287 27.7954L69.091 24.1989Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5668 31.3915C55.8815 25.4457 47.8704 21.7424 38.9943 21.7424C29.7512 21.7424 21.4461 25.7583 15.7285 32.1404L19.6061 35.6118C24.3707 30.2934 31.2916 26.9469 38.994 26.9469C46.3908 26.9469 53.0668 30.033 57.8046 34.9879L61.5668 31.3915Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0427 38.5841C50.2524 34.6202 44.9117 32.1513 38.9943 32.1513C32.8323 32.1513 27.2955 34.8285 23.4838 39.0833L27.3614 42.5546C30.2201 39.3636 34.3726 37.3558 38.994 37.3558C43.4321 37.3558 47.4377 39.2075 50.2804 42.1805L54.0427 38.5841Z",
    fill: "#BCB3D0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkLimiterEnabledMain);
export default __webpack_public_path__ + "static/media/networkLimiterEnabledMain.b9fc5708dc82947afad81eb3d91fa2f8.svg";
export { ForwardRef as ReactComponent };